import { FormComponentProps } from '../../components/FormComponent';
import { FormFieldTypes } from '../../components/FormFieldsComponent';

const FormBase = (
	onSubmit: FormComponentProps['onSubmit']
): FormComponentProps => {
	return {
		title: 'Reset Password',
		defaultValues: {
			code: '',
			password: '',
		},
		fields: [
			{
				id: 'code',
				type: FormFieldTypes.INPUT,
				config: {
					label: 'Code:',
				},
				validation: {
					required: true,
				},
			},
			{
				id: 'password',
				type: FormFieldTypes.INPUT,
				config: {
					label: 'New Password:',
					type: 'password',
					autoComplete: 'new-password',
				},
				validation: {
					required: true,
					pattern: {
						value:
							/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[\[\]{}()\\\/"'<>|~`=+#?!@$:%^&*\-_;.,]).{8,}$/,
						message:
							'Password require 1 lower and upper case letter, 1 number and 1 special character.',
					},
					defaultErrorMessage: 'Please enter a valid password.',
				},
			},
		],
		successCopy: "You're password has been successfully reset.",
		submitCopy: 'Reset Password',
		onSubmit,
	};
};

export default FormBase;
